import filter from "lodash/fp/filter";

export default function filterSkus(userChoicesValues) {
  return filter((sku) => {
    return Object.keys(sku.conditions).every((fieldName) => {
      const { includes, notIncludes } = sku.conditions[fieldName];

      const hasUserChoiceValue = userChoicesValues.hasOwnProperty(fieldName);
      const userChoiceValue = userChoicesValues[fieldName];

      if (
        notIncludes &&
        notIncludes.length > 0 &&
        !notIncludes.includes(userChoiceValue)
      ) {
        return true;
      }

      if (
        includes &&
        (includes.length === 0 || includes.includes(userChoiceValue))
      ) {
        return true;
      }

      if (!hasUserChoiceValue) {
        return true;
      }

      return false;
    });
  });
}
